import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as AvailableSpeedActions from './../actions/available-speed.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  AvailableSpeedResource,
  TechnicalError,
} from '@dch/products-business-logic';
import { AvailableSpeedService } from '../../services/available-speed.service';

@Injectable({
  providedIn: 'root',
})
export class AvailableSpeedEffects {
  @Effect()
  availableSpeed$: Observable<Action> = this.actions$.pipe(
    ofType(AvailableSpeedActions.GET_AVAILABLE_SPEED),
    switchMap((action: AvailableSpeedActions.GetAvailableSpeed) =>
      this.availableSpeedService.getAvailableSpeed(action.payload).pipe(
        map(
          (entity: IEntity<AvailableSpeedResource>) =>
            new AvailableSpeedActions.GetAvailableSpeedSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new AvailableSpeedActions.GetAvailableSpeedFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private availableSpeedService: AvailableSpeedService,
  ) {}
}
